import { getIn } from './getIn';
export const getCurrentApp = () => {
  // @ts-expect-error hubspot.bender lacks types
  if (!(window.hubspot && window.hubspot.bender)) {
    return null;
  }
  return window.hubspot.bender.currentProject;
};
export const isRecordPagePath = () => {
  return getCurrentApp() === 'crm-records-ui';
};
export const isHelpDeskPagePath = () => {
  return getCurrentApp() === 'svh-help-desk';
};
export const getLastSentReadyState = () => {
  const {
    objectId,
    objectTypeId
  } = getIn(['hsCalling', 'lastSentReadyState'], window, {});
  const result = {};
  if (objectId) {
    result.objectId = objectId;
  }
  if (objectTypeId) {
    result.objectTypeId = objectTypeId;
  }
  return result;
};
export const getLastSentThirdPartySubject = () => {
  const result = getIn(['hsCalling', 'lastSentThirdPartySubject'], window);
  if (result && result.objectId && result.objectTypeId) {
    return result;
  }
  return null;
};
export const getLastSentThirdPartySubjectFromParent = () => {
  // Access window.parent.hsCalling inside the navigation component iframe
  try {
    const result = getIn(['hsCalling', 'lastSentThirdPartySubject'], window.parent);
    if (result && result.objectId && result.objectTypeId) {
      return result;
    }
  } catch (e) {
    // do nothing
  }
  return null;
};
export const setLastSentThirdPartySubjectInParent = subject => {
  try {
    window.parent.hsCalling.lastSentThirdPartySubject = subject;
  } catch (e) {
    // do nothing
  }
};